import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LessonPlan } from 'src/app/_models/lessonPlan';
import { Member } from 'src/app/_models/member';
import { PlanMember } from 'src/app/_models/planMember';
import { AlertifyService } from 'src/app/_services/alertify.service';
import { AuthService } from 'src/app/_services/auth.service';
import { PlanService } from 'src/app/_services/plan.service';

@Component({
  selector: 'app-viewLessonPlan',
  standalone: true,
  imports: [ CommonModule],
  templateUrl: './viewLessonPlan.component.html',
  styleUrls: ['./viewLessonPlan.component.css']
})
export class ViewLessonPlanComponent implements OnInit {
  member: Member;
  lessonPlan : LessonPlan;

  constructor(
    private route: ActivatedRoute
    , private router: Router
    , private alertify: AlertifyService
    , private planService: PlanService
    , private authService: AuthService
    , public datePipe: DatePipe) { }

  ngOnInit() {

    this.member = this.authService.currentMember;
    this.route.params.subscribe((params) => {
      if (params) {
        const lessonPlanId = params.id;
        this.planService.getLessonPlan(lessonPlanId).subscribe(lessonPlan => {
          if (lessonPlan.planItems.length > 0)
          {
            var itemPatterns = lessonPlan.planItems.filter(pi => pi.type == 'Pattern');
            var patternSequence = 0;
            for (var pattern of itemPatterns) {
              patternSequence ++;
              lessonPlan.planItems.find(pi => pi.id == pattern.id).patternSequence = patternSequence;
            }
          }
          this.lessonPlan = lessonPlan;
        }, error => {
          this.alertify.error(error);
        });        
      } 
     });
  }

    displayParticipants(planMembers: PlanMember[]) {
      return planMembers.filter(pm => pm.member != null).map(pm => pm.member.knownAs).join(', ');
    }
    
    displayInvitees(planMembers: PlanMember[]) {
      return planMembers.filter(pm => pm.member === null).map(pm => pm.emailAddress).join(', ');;
    }

    navigateToNotes(planItemId: number) {
      this.router.navigate(['lessonPlan/planItem/' + planItemId]);
    }

}
